<div class="container">
  <div class="column first-column">
    <div class="row">&nbsp;</div>
    <div class="row">Package</div>

    <!-- First package -->
    <div class="row">
      <div class="select-container">
        <span class="delete-icon" (click)="clearPackageSelection(0)">✕</span>
        <div class="custom-select-wrapper">
          <input
            type="text"
            class="custom-select-input"
            [formControl]="packageControl1"
            [matAutocomplete]="auto1"
            (blur)="onPackageInputBlur(0)"
          />
          <mat-autocomplete
            #auto1="matAutocomplete"
            [displayWith]="displayFn"
            (optionSelected)="onPackageSelected($event, 0)"
            panelClass="custom-autocomplete-panel"
          >
            <cdk-virtual-scroll-viewport
              itemSize="36"
              class="autocomplete-viewport"
            >
              <mat-option
                *cdkVirtualFor="let item of filteredPackages1"
                [value]="item"
              >
                {{ item.Package }}
              </mat-option>
            </cdk-virtual-scroll-viewport>
          </mat-autocomplete>
        </div>
      </div>
    </div>

    <!-- Second package -->
    <div class="row">
      <div class="select-container">
        <span class="delete-icon" (click)="clearPackageSelection(1)">✕</span>
        <div class="custom-select-wrapper">
          <input
            type="text"
            class="custom-select-input"
            [formControl]="packageControl2"
            [matAutocomplete]="auto2"
            (blur)="onPackageInputBlur(1)"
          />
          <mat-autocomplete
            #auto2="matAutocomplete"
            [displayWith]="displayFn"
            (optionSelected)="onPackageSelected($event, 1)"
            panelClass="custom-autocomplete-panel"
          >
            <cdk-virtual-scroll-viewport
              itemSize="36"
              class="autocomplete-viewport"
            >
              <mat-option
                *cdkVirtualFor="let item of filteredPackages2"
                [value]="item"
              >
                {{ item.Package }}
              </mat-option>
            </cdk-virtual-scroll-viewport>
          </mat-autocomplete>
        </div>
      </div>
    </div>
  </div>
  <div class="column second-column"></div>
  <div class="column second-column"></div>
  <div class="column second-column">
    <div class="row centered">Blend 1</div>
    <div class="row centered">Treat [wt%]</div>
    <div class="row centered">
      <input
        type="text"
        inputmode="decimal"
        placeholder=""
        [formControl]="treat1P1Control"
        (keydown)="restrictNumericInput($event)"
        (focus)="onTreatFocus(0, 0)"
        (input)="handleTreatInput($event, 0, 0)"
        (focus)="onTreatFocus(0, 0)"
        (blur)="onTreatBlur(0, 0)"
      />
    </div>
    <div class="row centered">
      <input
        type="text"
        inputmode="decimal"
        placeholder=""
        [formControl]="treat1P2Control"
        (keydown)="restrictNumericInput($event)"
        (focus)="onTreatFocus(1, 0)"
        (input)="handleTreatInput($event, 1, 0)"
        (focus)="onTreatFocus(1, 0)"
        (blur)="onTreatBlur(1, 0)"
      />
    </div>
  </div>
  <div class="column second-column"></div>
  <div class="column third-column">
    <div class="row centered">Blend 2</div>
    <div class="row centered">Treat [wt%]</div>
    <div class="row centered">
      <input
        type="text"
        inputmode="decimal"
        placeholder=""
        [formControl]="treat2P1Control"
        (keydown)="restrictNumericInput($event)"
        (focus)="onTreatFocus(0, 1)"
        (input)="handleTreatInput($event, 0, 1)"
        (focus)="onTreatFocus(0, 1)"
        (blur)="onTreatBlur(0, 1)"
      />
    </div>
    <div class="row centered">
      <input
        type="text"
        inputmode="decimal"
        placeholder=""
        [formControl]="treat2P2Control"
        (keydown)="restrictNumericInput($event)"
        (focus)="onTreatFocus(1, 1)"
        (input)="handleTreatInput($event, 1, 1)"
        (focus)="onTreatFocus(1, 1)"
        (blur)="onTreatBlur(1, 1)"
      />
    </div>
  </div>
</div>
